<template>
  <b-card class="mt-2">
    <template #header>
      <div class="row justify-content-between">
        <div class="col-auto">
          <b-badge variant="success" class="mr-2 fs-6">{{
            'Produtos da Campanha'
          }}</b-badge>
        </div>

        <div class="col-auto">
          <h5
            :class="{
              'text-danger': this.valorMinimoPedido > valorTotal,
              'text-success': this.valorMinimoPedido < valorTotal,
            }"
          >
            {{ 'Valor Total: ' + format(valorTotal, config) }}
          </h5>
        </div>
      </div>
    </template>

    <DataTable
      :rowClass="rowClass"
      :value="this.pedido.produtosPedido"
      :multiSortMeta="multiSortMeta"
      sortMode="multiple"
      responsiveLayout="scroll"
    >
      <Column field="cean" header="CEAN" sortable></Column>
      <Column field="descricao" header="Descrição" sortable></Column>
      <Column
        field="compra_obrigatorio"
        header="Obrigatório?"
        class="text-center"
        :sortable="true"
      >
        <template #body="item">
          <div>
            {{ item.data.compra_obrigatorio == 'S' ? 'Sim' : 'Não' }}
          </div>
        </template>
      </Column>
      <Column
        class="text-center"
        field="quant_minima"
        header="Quantidade Mínima"
        :sortable="true"
      >
        <template #body="item">
          <div>
            {{ parseInt(item.data.quant_minima) }}
          </div>
        </template>
      </Column>
      <Column
        field="valor_unitario"
        header="Preço Final"
        class="text-center"
        :sortable="true"
      >
        <template #body="item">
          <div>
            {{ format(parseFloat(item.data.valor_unitario), config) }}
          </div>
        </template>
      </Column>
      <Column field="quant_solicitada" header="Qtde. Solicitada">
        <template #body="item">
          <b-form-group>
            <b-form-input
              :id="`${item.data.id}`"
              type="number"
              min="0"
              max=""
              class="input-qtde"
              v-model="item.data.quant_solicitada"
              @input="(v) => this.atualizaQuantidade(v, item)"
            ></b-form-input>
          </b-form-group>
        </template>
      </Column>
      <Column header="Total" class="text-center">
        <template #body="item">
          <div>
            {{
              format(
                parseFloat(
                  item.data.valor_unitario * item.data.quant_solicitada,
                ),
                config,
              )
            }}
          </div>
        </template>
      </Column>
    </DataTable>
  </b-card>
</template>
<script>
import { format } from 'v-money3'
import config from '@/functions/formatMoney'

export default {
  props: ['pedidoInfo', 'validaPedido', 'valorMinimoPedido'],
  setup() {},
  data() {
    return {
      format: format,
      config: config,
      valorTotal: 0,
      pedido: this.pedidoInfo,
      fields: [],
    }
  },
  created() {
    this.calculaValorTotal()
  },
  methods: {
    calculaValorTotal() {
      this.valorTotal = 0
      const listaProdutos = this.pedido.produtosPedido
      for (let i = 0; i < listaProdutos.length; i++) {
        const produto = listaProdutos[i]
        this.valorTotal +=
          produto.quant_solicitada != null
            ? parseFloat(
                parseInt(produto.quant_solicitada) *
                  parseFloat(produto.valor_unitario),
              )
            : 0
      }
    },
    rowClass(item) {
      if (item.compra_obrigatorio == 'S') {
        if (parseInt(item.quant_minima) > 0) {
          if (parseInt(item.quant_solicitada) >= parseInt(item.quant_minima)) {
            return 'green-line'
          } else {
            return 'orange-line'
          }
        } else {
          return null
        }
      } else {
        if (
          parseInt(item.quant_solicitada) > 0 &&
          parseInt(item.quant_solicitada) >= parseInt(item.quant_minima)
        ) {
          return 'green-line'
        } else if (
          parseInt(item.quant_minima) > parseInt(item.quant_solicitada) &&
          parseInt(item.quant_minima) > 0 &&
          parseInt(item.quant_solicitada) > 0
        ) {
          return 'orange-line'
        } else {
          return null
        }
      }
    },
    atualizaQuantidade(v, item) {
      v = parseInt(v) > 999999 ? 999999 : Math.trunc(v)

      const index = this.pedido.produtosPedido.findIndex(
        (x) => x.cean == item.data.cean,
      )
      this.pedido.produtosPedido[index].quant_solicitada = parseInt(v)

      this.valorTotal = 0
      const listaProdutos = this.pedido.produtosPedido
      for (let i = 0; i < listaProdutos.length; i++) {
        const produto = listaProdutos[i]
        this.valorTotal +=
          produto.quant_solicitada != null
            ? parseFloat(
                parseInt(produto.quant_solicitada) *
                  parseFloat(produto.valor_unitario),
              )
            : 0
      }

      this.$emit('validaPedido', this.pedido)
    },
  },
}
</script>
<style scoped>
.input-qtde {
  position: relative;
  top: 7px;
  width: 150px;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 0rem !important;
}

.orange-line {
  background-color: #eab676 !important;
  padding: 0rem 0.5rem !important;
}

.green-line {
  background-color: #76eab6 !important;
  padding: 0rem 0.5rem !important;
}
</style>
